import {Component, Input, Output, EventEmitter, AfterViewInit,ChangeDetectionStrategy} from '@angular/core';
import {AppService} from "@irb/app.service";
import {IrbAppEvents} from "@irb/app.events";
import {IAlertDialogData} from "@irb/app.model";

@Component({
  selector: 'irb-text-editor',
  standalone: false,
  templateUrl: './text-editor.component.html',
  styleUrl: './text-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class TextEditorComponent implements AfterViewInit {
  @Input() text: string | undefined;
  @Output() textChange = new EventEmitter<string>();
  @Output() change = new EventEmitter<string>();
  doc: any;
  docContent: any;
  
  constructor(private as: AppService) {}

  ngAfterViewInit(): void {
     this.load();
  }
  
  load() {
      const doc: any = document.getElementById("irb-text-editor-text-elem");

      if (doc) {
          this.doc = doc.contentDocument;
          this.doc.designMode = "On";
          this.docContent = this.doc.body;
          this.docContent.style.fontFamily = "sans-serif";
          this.docContent.style.fontSize = "11px";
          this.docContent.style.fontWeight = "normal";
          this.docContent.style.overflowX = "hidden";
          this.docContent.innerHTML = this.text;

          this.docContent.addEventListener('keyup', () => {
              this.onChange();
          }, false);
      }
  }

  cleanDoc() {
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            msg: "Delete all the contents?",
            dCancelBtnLabel: "Cancel",
            onProceed: (() => {
                this.docContent.innerHTML = '';
                this.docContent.focus();
                this.onChange();
            }).bind(this)
        } as IAlertDialogData);
  }

  printDoc() {
      const printedHtml = this.docContent.innerHTML;
      let p = window.open("","_blank");

      if (p && p.document) {
          let doc = p.document;
          let headElements = doc.getElementsByTagName('head');
          let headElement = headElements[0];
          let titleElement = doc.createElement('title');
          titleElement.innerText = "Print";
          headElement.appendChild(titleElement);
          let bodyElements = doc.getElementsByTagName('body');
          let bodyElement = bodyElements[0];
          bodyElement.setAttribute('onload', 'print();');
          let wrapperElement = doc.createElement('div');
          let docFragment = doc.createRange().createContextualFragment(printedHtml);
          wrapperElement.appendChild(docFragment);
          let scriptElement = document.createElement('script');
          scriptElement.setAttribute('type', 'text/javascript');
          scriptElement.innerText = 'print();'
          bodyElement.appendChild(wrapperElement);
          bodyElement.appendChild(scriptElement);
      }
  }

  formatDoc(command: any) {
      this.doc?.execCommand(command);
      this.onChange();
  }

  addLink() {
      let sLnk = window.prompt('Enter the URL here','http:\/\/');

      if (sLnk && sLnk !== '' && sLnk !== 'http://') {
        this.doc?.execCommand("CreateLink", false, sLnk);
        this.onChange();
      }
  }

  onChange() {
    let d = this.docContent.innerHTML.trim();

    if (d === '<br>') {
        d = '';
    }

    this.textChange.emit(d);
    this.change.emit(d);
  }
}
